import {XauditModel} from '../../xaudit.model';
import {NotificationToFrontOperatoryDataModel} from './notification-to-front-operatory-data.model';

export class NotificationToFrontAppointmentDataModel extends XauditModel {
  NoteToFrontApptID: string;
  NotificationFrontID: string;
  nOrder: number;
  enumNextApptID: string;
  enumNextApptLengthID: string;
  enumNextApptWhenID: string;
  AppointmentId: string;

  dataNotificationToFrontOperatories: NotificationToFrontOperatoryDataModel[] = [];
}
